// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__hpSwV","itemTitle":"ClientEmergencyInfo_itemTitle__15930","itemText":"ClientEmergencyInfo_itemText__2wje5"};